/* eslint-disable */
import { Illustration } from './components/illustration';
import { default as AlerteElement } from '../assets/illustrations/Alerte.svg?react';
import { default as AnnoncesElement } from '../assets/illustrations/Annonces.svg?react';
import { default as ApplicationOKElement } from '../assets/illustrations/ApplicationOK.svg?react';
import { default as AttenteElement } from '../assets/illustrations/Attente.svg?react';
import { default as BinocularBlueElement } from '../assets/illustrations/BinocularBlue.svg?react';
import { default as BinocularJauneElement } from '../assets/illustrations/BinocularJaune.svg?react';
import { default as BinocularLightBlueElement } from '../assets/illustrations/BinocularLightBlue.svg?react';
import { default as BuildingElement } from '../assets/illustrations/Building.svg?react';
import { default as BullesElement } from '../assets/illustrations/Bulles.svg?react';
import { default as BusinessElement } from '../assets/illustrations/Business.svg?react';
import { default as BusinessAElement } from '../assets/illustrations/BusinessA.svg?react';
import { default as BusinessBElement } from '../assets/illustrations/BusinessB.svg?react';
import { default as CaElement } from '../assets/illustrations/Ca.svg?react';
import { default as CartableElement } from '../assets/illustrations/Cartable.svg?react';
import { default as ChariotElement } from '../assets/illustrations/Chariot.svg?react';
import { default as CibleElement } from '../assets/illustrations/Cible.svg?react';
import { default as ClientsElement } from '../assets/illustrations/Clients.svg?react';
import { default as CommandesElement } from '../assets/illustrations/Commandes.svg?react';
import { default as CompteFavorisElement } from '../assets/illustrations/CompteFavoris.svg?react';
import { default as ConflictElement } from '../assets/illustrations/Conflict.svg?react';
import { default as ContactBisElement } from '../assets/illustrations/ContactBis.svg?react';
import { default as ContratsElement } from '../assets/illustrations/Contrats.svg?react';
import { default as DerniereActionCAElement } from '../assets/illustrations/DerniereActionCA.svg?react';
import { default as DerniereRechercheBeigeElement } from '../assets/illustrations/DerniereRechercheBeige.svg?react';
import { default as DerniereRechercheGreenishElement } from '../assets/illustrations/DerniereRechercheGreenish.svg?react';
import { default as DernieresActionsElement } from '../assets/illustrations/DernieresActions.svg?react';
import { default as DonutElement } from '../assets/illustrations/Donut.svg?react';
import { default as EmpreinteElement } from '../assets/illustrations/Empreinte.svg?react';
import { default as EmptyStateElement } from '../assets/illustrations/EmptyState.svg?react';
import { default as EquivalenceElement } from '../assets/illustrations/Equivalence.svg?react';
import { default as EyeElement } from '../assets/illustrations/Eye.svg?react';
import { default as FavorisElement } from '../assets/illustrations/Favoris.svg?react';
import { default as FlecheTTElement } from '../assets/illustrations/FlecheTT.svg?react';
import { default as HeuresElement } from '../assets/illustrations/Heures.svg?react';
import { default as InterimairesElement } from '../assets/illustrations/Interimaires.svg?react';
import { default as LesionsElement } from '../assets/illustrations/Lesions.svg?react';
import { default as LoaderElement } from '../assets/illustrations/Loader.svg?react';
import { default as LoaderSmallElement } from '../assets/illustrations/LoaderSmall.svg?react';
import { default as LookElement } from '../assets/illustrations/Look.svg?react';
import { default as MainsElement } from '../assets/illustrations/Mains.svg?react';
import { default as MapLoadingElement } from '../assets/illustrations/MapLoading.svg?react';
import { default as OiseElement } from '../assets/illustrations/Oise.svg?react';
import { default as OpportunitiesElement } from '../assets/illustrations/Opportunities.svg?react';
import { default as PastequeElement } from '../assets/illustrations/Pasteque.svg?react';
import { default as PauseElement } from '../assets/illustrations/Pause.svg?react';
import { default as PbUniteElement } from '../assets/illustrations/PbUnite.svg?react';
import { default as PermisAElement } from '../assets/illustrations/PermisA.svg?react';
import { default as PermisA1Element } from '../assets/illustrations/PermisA1.svg?react';
import { default as PermisA2Element } from '../assets/illustrations/PermisA2.svg?react';
import { default as PermisAMElement } from '../assets/illustrations/PermisAM.svg?react';
import { default as PermisBElement } from '../assets/illustrations/PermisB.svg?react';
import { default as PermisB1Element } from '../assets/illustrations/PermisB1.svg?react';
import { default as PermisBEElement } from '../assets/illustrations/PermisBE.svg?react';
import { default as PermisCElement } from '../assets/illustrations/PermisC.svg?react';
import { default as PermisC1Element } from '../assets/illustrations/PermisC1.svg?react';
import { default as PermisC1EElement } from '../assets/illustrations/PermisC1E.svg?react';
import { default as PermisCEElement } from '../assets/illustrations/PermisCE.svg?react';
import { default as PermisDElement } from '../assets/illustrations/PermisD.svg?react';
import { default as PermisD1Element } from '../assets/illustrations/PermisD1.svg?react';
import { default as PermisD1EElement } from '../assets/illustrations/PermisD1E.svg?react';
import { default as PermisDEElement } from '../assets/illustrations/PermisDE.svg?react';
import { default as PertinenceElement } from '../assets/illustrations/Pertinence.svg?react';
import { default as PigeElement } from '../assets/illustrations/Pige.svg?react';
import { default as PlusElement } from '../assets/illustrations/Plus.svg?react';
import { default as PrincipaleElement } from '../assets/illustrations/Principale.svg?react';
import { default as RechercheElement } from '../assets/illustrations/Recherche.svg?react';
import { default as RechercheFavoriteElement } from '../assets/illustrations/RechercheFavorite.svg?react';
import { default as RepositioningElement } from '../assets/illustrations/Repositioning.svg?react';
import { default as RepositionnementElement } from '../assets/illustrations/Repositionnement.svg?react';
import { default as ScopeElement } from '../assets/illustrations/Scope.svg?react';
import { default as ScopeIntroElement } from '../assets/illustrations/ScopeIntro.svg?react';
import { default as ServerErrorRedElement } from '../assets/illustrations/ServerErrorRed.svg?react';
import { default as ServerErrorWhiteElement } from '../assets/illustrations/ServerErrorWhite.svg?react';
import { default as ServerErrorYellowElement } from '../assets/illustrations/ServerErrorYellow.svg?react';
import { default as ServerErrorYellowSmallElement } from '../assets/illustrations/ServerErrorYellowSmall.svg?react';
import { default as ServicesElement } from '../assets/illustrations/Services.svg?react';
import { default as TchinElement } from '../assets/illustrations/Tchin.svg?react';
import { default as VideActionsElement } from '../assets/illustrations/VideActions.svg?react';
import { default as VideBleuElement } from '../assets/illustrations/VideBleu.svg?react';
import { default as VidePastequeElement } from '../assets/illustrations/VidePasteque.svg?react';
import { default as VideTransparentElement } from '../assets/illustrations/VideTransparent.svg?react';

export const Alerte = Illustration(AlerteElement);
export const Annonces = Illustration(AnnoncesElement);
export const ApplicationOK = Illustration(ApplicationOKElement);
export const Attente = Illustration(AttenteElement);
export const BinocularBlue = Illustration(BinocularBlueElement);
export const BinocularJaune = Illustration(BinocularJauneElement);
export const BinocularLightBlue = Illustration(BinocularLightBlueElement);
export const Building = Illustration(BuildingElement);
export const Bulles = Illustration(BullesElement);
export const Business = Illustration(BusinessElement);
export const BusinessA = Illustration(BusinessAElement);
export const BusinessB = Illustration(BusinessBElement);
export const Ca = Illustration(CaElement);
export const Cartable = Illustration(CartableElement);
export const Chariot = Illustration(ChariotElement);
export const Cible = Illustration(CibleElement);
export const Clients = Illustration(ClientsElement);
export const Commandes = Illustration(CommandesElement);
export const CompteFavoris = Illustration(CompteFavorisElement);
export const Conflict = Illustration(ConflictElement);
export const ContactBis = Illustration(ContactBisElement);
export const Contrats = Illustration(ContratsElement);
export const DerniereActionCA = Illustration(DerniereActionCAElement);
export const DerniereRechercheBeige = Illustration(DerniereRechercheBeigeElement);
export const DerniereRechercheGreenish = Illustration(DerniereRechercheGreenishElement);
export const DernieresActions = Illustration(DernieresActionsElement);
export const Donut = Illustration(DonutElement);
export const Empreinte = Illustration(EmpreinteElement);
export const EmptyState = Illustration(EmptyStateElement);
export const Equivalence = Illustration(EquivalenceElement);
export const Eye = Illustration(EyeElement);
export const Favoris = Illustration(FavorisElement);
export const FlecheTT = Illustration(FlecheTTElement);
export const Heures = Illustration(HeuresElement);
export const Interimaires = Illustration(InterimairesElement);
export const Lesions = Illustration(LesionsElement);
export const Loader = Illustration(LoaderElement);
export const LoaderSmall = Illustration(LoaderSmallElement);
export const Look = Illustration(LookElement);
export const Mains = Illustration(MainsElement);
export const MapLoading = Illustration(MapLoadingElement);
export const Oise = Illustration(OiseElement);
export const Opportunities = Illustration(OpportunitiesElement);
export const Pasteque = Illustration(PastequeElement);
export const Pause = Illustration(PauseElement);
export const PbUnite = Illustration(PbUniteElement);
export const PermisA = Illustration(PermisAElement);
export const PermisA1 = Illustration(PermisA1Element);
export const PermisA2 = Illustration(PermisA2Element);
export const PermisAM = Illustration(PermisAMElement);
export const PermisB = Illustration(PermisBElement);
export const PermisB1 = Illustration(PermisB1Element);
export const PermisBE = Illustration(PermisBEElement);
export const PermisC = Illustration(PermisCElement);
export const PermisC1 = Illustration(PermisC1Element);
export const PermisC1E = Illustration(PermisC1EElement);
export const PermisCE = Illustration(PermisCEElement);
export const PermisD = Illustration(PermisDElement);
export const PermisD1 = Illustration(PermisD1Element);
export const PermisD1E = Illustration(PermisD1EElement);
export const PermisDE = Illustration(PermisDEElement);
export const Pertinence = Illustration(PertinenceElement);
export const Pige = Illustration(PigeElement);
export const Plus = Illustration(PlusElement);
export const Principale = Illustration(PrincipaleElement);
export const Recherche = Illustration(RechercheElement);
export const RechercheFavorite = Illustration(RechercheFavoriteElement);
export const Repositioning = Illustration(RepositioningElement);
export const Repositionnement = Illustration(RepositionnementElement);
export const Scope = Illustration(ScopeElement);
export const ScopeIntro = Illustration(ScopeIntroElement);
export const ServerErrorRed = Illustration(ServerErrorRedElement);
export const ServerErrorWhite = Illustration(ServerErrorWhiteElement);
export const ServerErrorYellow = Illustration(ServerErrorYellowElement);
export const ServerErrorYellowSmall = Illustration(ServerErrorYellowSmallElement);
export const Services = Illustration(ServicesElement);
export const Tchin = Illustration(TchinElement);
export const VideActions = Illustration(VideActionsElement);
export const VideBleu = Illustration(VideBleuElement);
export const VidePasteque = Illustration(VidePastequeElement);
export const VideTransparent = Illustration(VideTransparentElement);
